import { staffDate } from "@/lib/staff-identity";
import type { OvertimeMultipliers, OvertimeType, PayEmployee, PayLine } from "./use-staff-pay";

export const overtimeDefaults:OvertimeMultipliers={hd:1.35,hn:1.7,rest:2,hol:2};
export const overtimeTypes:Record<OvertimeType,{name:string;unit:"hours"|"days"}>={
  hd:{name:"Extra hours, day",unit:"hours"},hn:{name:"Extra hours, night",unit:"hours"},
  rest:{name:"Worked a rest day",unit:"days"},hol:{name:"Worked an official holiday",unit:"days"},
};
export const overtimeReasons=["Covering an absence","Busy period","Short staffed","Event or catering","Stock count or delivery","Something else"];
export const overtimeReasonGroup=(reason?:string|null)=>reason?.startsWith("Something else:")?"Something else":reason||"Not given";
export function overtimeRate(employee:PayEmployee,type:OvertimeType,multipliers=overtimeDefaults){
  return Number(employee.payAmount||0)/(employee.payPer==="day"?1:30)/(overtimeTypes[type].unit==="hours"?8:1)*multipliers[type];
}
export function overtimeLine(employee:PayEmployee,line:PayLine,multipliers=overtimeDefaults):PayLine{
  const type=line.overtimeType||"hd",unit=overtimeTypes[type].unit,quantity=Number(line.overtimeQty)||0;
  return {...line,kind:"extra",overtimeType:type,overtimeUnit:unit,overtimeMultiplier:multipliers[type],
    amount:String(Math.round(overtimeRate(employee,type,multipliers)*quantity)),
    label:`Overtime · ${overtimeTypes[type].name} · ${quantity} ${unit==="hours"?(quantity===1?"hour":"hours"):(quantity===1?"day":"days")} · ${line.overtimeDate?staffDate(line.overtimeDate):""}`};
}
export function overtimeValid(line:PayLine){
  return !line.overtimeType||!!line.overtimeDate&&Number(line.overtimeQty)>0&&!!line.overtimeReason?.trim()&&
    (overtimeReasonGroup(line.overtimeReason)!=="Something else"||/^Something else:\s*\S/.test(line.overtimeReason));
}
